import Vue from 'vue';
import VueResource from 'vue-resource';
import VueProgressBar from 'vue-progressbar';
import VueResourceProgressBarInterceptor from 'vue-resource-progressbar-interceptor';

import RequestQueue from './requestQueue';
import interceptors from './interceptors';
import { apiUrl } from './constants';

Vue.use(VueResource);
Vue.http.options.root = apiUrl;
Vue.http.headers.common['LOGIN-SOURCE'] = 'PISHKHAN';

export const requestQueue = new RequestQueue({
  canceller(request) {
    if (request) {
      request.abort();
    }
  },
});

Vue.use(interceptors, { requestQueue });

Vue.use(VueProgressBar, {
  color: 'red',
  height: '3px',
});
Vue.use(VueResourceProgressBarInterceptor);
